import { AccommodationCase } from '../../../../../data-models';

import {
  HighlightNote,
  Text,
  SingleBorderContainer,
} from '../../../tw-components';

type AccommodationCardItemProps = {
  accommodationCase: AccommodationCase;
};

type AccommodationCardListProps = {
  cases: AccommodationCase[];
};

const PostIntakeAccommodations = ({ cases }: AccommodationCardListProps) => {
  return (
    <div className="tw-pb-2">
      {cases.map((ac) => (
        <AccommodationItem key={ac.caseId} accommodationCase={ac} />
      ))}
    </div>
  );
};

const AccommodationItem = ({
  accommodationCase,
}: AccommodationCardItemProps) => {
  return (
    <>
      <div className="tw-mb-5">
        <HighlightNote>
          We are currently evaluating your request and all applicable coverages
          for your case and will provide an update to you. Please allow up to
          five business days for an update.
        </HighlightNote>
      </div>

      <div className="tw-mb-5">
        <SingleBorderContainer>
          <Text
            className="tw-w-full tw-mb-6"
            align="center"
            color="unm-interactive01-400"
          >
            Summary of request
          </Text>
          {accommodationCase?.accommodations?.map((accm, i) => {
            const mappedRequest =
              accm?.accommodationType?.name?.trim() ??
              accm?.categoryName?.trim() ??
              '';

            return (
              <div key={`accm-item-${accm?.accommodationType?.name}-${i}`}>
                <div className="tw-mb-6 tw-flex tw-flex-row tw-justify-around">
                  <div className="tw-flex tw-flex-col tw-items-center tw-gap-3">
                    <Text align="center" fontWeight="semibold">
                      Request
                    </Text>
                    <Text align="center">{mappedRequest}</Text>
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-center tw-gap-3">
                    <Text align="center" fontWeight="semibold">
                      Status
                    </Text>
                    <Text align="center">{accm.decision}</Text>
                  </div>
                </div>
              </div>
            );
          })}
          <Text className="tw-w-full" align="center">
            A member of our team will be contacting you via telephone within 2
            business days to discuss your request above.
          </Text>
        </SingleBorderContainer>
      </div>
    </>
  );
};

export default PostIntakeAccommodations;
